export default __webpack_public_path__ + "static/media/sent-email.29da8a87.svg";